export interface SetPositionInput {
  /** Index into the items, the overview included when there is one */
  index: number
  count: number
  /** Item 0 is the set's own overview (a setlist, page or folder), which is not a song */
  hasOverview: boolean
  /** "Song" or "Track" */
  noun: string
}

export interface SetPosition {
  isOverview: boolean
  /** "2 / 19" or "Overview" */
  short: string
  /** "Song 2 of 19" or "Overview" */
  long: string
}

/** Where the performer is in the set. The overview is not a song, so the songs count from 1 after it. */
export const setPosition = ({ index, count, hasOverview, noun }: SetPositionInput): SetPosition => {
  if (hasOverview && index === 0) {
    return { isOverview: true, short: 'Overview', long: 'Overview' }
  }
  const offset = hasOverview ? 0 : 1
  const n = index + offset
  const total = count - 1 + offset
  return { isOverview: false, short: `${n} / ${total}`, long: `${noun} ${n} of ${total}` }
}
